import React from "react";

import { FIELD_TYPE, FORMAT_TIME, tabKeys, TT_PHIEU_VTYT, TT_VTYT } from "types/enums";
import { DataFormField } from "types/models/input-field-type";
import { ColumnsEdit } from "types/models/column-table-edit";
import {
  Button,
  Form,
  notification,
  Popconfirm,
  Row,
  Space,
  Tooltip,
  Typography,
} from "antd";
import { listGender, listMarriage } from "../../../../../../data/list";
import { ListActionButton } from "../../../../../../components/common";
import { useAppDispatch } from "../../../../../../redux/hooks";
import { setEBCType } from "../../../../../../redux/reducer/examBtnClick";
import { EXAM_BTN_CLICK_TYPE } from "../../../../../../types/enums/examination";
import {
  setExaminationId,
  setIdPKNT,
} from "../../../../../../redux/reducer/examination";
import { setActiveKey } from "../../../../../../redux/reducer/common";
import Icons from "../../../../../../assets/icons";
import { updatePhieuKhamNT } from "../../../../../Examination/components/ListExam/ListExam.config";
import { ReactComponent as EyeIconSVG } from "assets/images/svg/eye.svg";
const { INPUT, DATE, COMBO_BOX, AUTO_COMPLETE, CODE, NUMBER,DATE_DAY_INPUT } = FIELD_TYPE;
import { employeeService } from "api";
import { ColumnProps } from "../../../../../../types/models";
import { formatPhoneNumber } from "../../../../../../helper/format-phone";
import { validatePhoneNumberLength } from "../../../../../../helper/common";
import dayjs from 'dayjs';
import { render } from 'react-dom';
import moment from "moment";
import { format } from "path";
const TEL_NUMBER_REGEX = /^[0-9-]*$/;
const normalizePhoneNumber = (_, value) => {
  // Xóa khoảng trắng và dấu gạch ngang trong chuỗi số điện thoại (nếu có)
  const cleanPhoneNumber = value.replace(/\s|-/g, "");

  // Kiểm tra xem có phải là số và có đúng 10 chữ số không
  const isNumber = /^\d+$/.test(cleanPhoneNumber);

  if (isNumber && cleanPhoneNumber.length === 10) {
    const normalizedPhoneNumber = cleanPhoneNumber.replace(
      /(\d{4})(\d{2})(\d{2})(\d{2})/,
      "$1 $2 $3 $4"
    );
    return Promise.resolve();
  } else {
    return Promise.reject(
      new Error("Số điện thoại phải là số và nhập đúng 10 chữ số")
    );
  }
};

const allColumns: ColumnProps[] = [
  {
    title: "STT",
    key: "index",
    show: true,
    isResizable: true,
    width: 40,
    dataIndex: "index",
    render(_, __, index) {
      return <>{index + 1}</>;
    },
    disabledCheck: true,
    fixed: "left",
    align: "center",
  },
  {
    title: "Mã nhân viên",
    key: "maNhanVien",
    dataIndex: "maNhanVien",
    show: true,
    isResizable: true,
    width: 120,
    align: "left",
    fixed: "left",
  },
  {
    title: "Họ tên",
    key: "hoTen",
    show: true,
    dataIndex: "hoTen",
    align: "left",
    width: 120,
    fixed: "left",
    isResizable: true,
  },
  {
    title: "Giới tính",
    key: "idGioiTinh",
    show: true,
    dataIndex: "idGioiTinh",
    align: "center",
    width: 70,
    isResizable: true,
    render: (v, r, i) => listGender.find((it) => it.value === v)?.label || "",
  },
  {
    title: "TK đăng nhập",
    key: "taiKhoanDangNhap",
    show: false,
    dataIndex: "taiKhoanDangNhap",
   // render: (v) => formatPhoneNumber(v),
    align: "center",
    width: 120,
    isResizable: true,
  },
  {
    title: "Điện thoại di động",
    key: "dienThoaiDiDong",
    show: false,
    dataIndex: "dienThoaiDiDong",
   // render: (v) => formatPhoneNumber(v),
    align: "center",
    width: 120,
    isResizable: true,
  },
  {
    title: "Ngày sinh",
    key: "birthday",
    show: true,
    dataIndex: "birthday",
   // render: (v, r, idx) => v !== null ? dayjs(v).format("DD/MM/YYYY") : null ,
    align: "center",
    width: 100,
    isResizable: true,
  },
  {
    title: "Chức vụ",
    key: "chucVu",
    show: true,
    dataIndex: "chucVu",
    width: 250,
    align: "left",
    isResizable: true,
  },
  {
    title: "Chức vụ TA",
    key: "chucVuTA",
    show: false,
    dataIndex: "chucVuTA",
    width: 250,
    align: "left",
    isResizable: true,
  },
  {
    title: "Vai trò",
    key: "idVaiTro",
    show: true,
    dataIndex: "idVaiTro",
    width: 120,
    align: "left",
    isResizable: true,
  },
  {
    title: "Trạng Thái",
    key: "trangThai",
    show: true,
    dataIndex: "trangThai",
    width: 150,
    align: "left",
    isResizable: true,
  },
  {
    title: "Người quản lý trực tiếp",
    key: "nguoiQuanLyTrucTiep",
    show: false,
    dataIndex: "nguoiQuanLyTrucTiep",
    width: 100,
    align: "left",
    isResizable: true,
  },
  {
    title: "Nơi sinh",
    key: "noiSinh",
    show: false,
    dataIndex: "noiSinh",
    width: 80,
    align: "left",
    isResizable: true,
  },
  {
    title: "Hộ khẩu",
    key: "hoKhau",
    show: false,
    dataIndex: "hoKhau",
    width: 80,
    isResizable: true,
    align: "left",
  },
  {
    title: "Quốc tịch",
    key: "quocTich",
    show: false,
    dataIndex: "quocTich",
    width: 80,
    align: "left",
    isResizable: true,
  },
  {
    title: "Quốc tịch TA",
    key: "quocTich TA",
    show: false,
    dataIndex: "quocTichTA",
    width: 80,
    align: "left",
    isResizable: true,
  },
  {
    title: "Tôn giáo",
    key: "tonGiao",
    show: false,
    dataIndex: "tonGiao",
    width: 80,
    align: "left",
    isResizable: true,
  },
  {
    title: "Dân tộc",
    key: "danToc",
    show: false,
    dataIndex: "danToc",
    width: 80,
    align: "left",
    isResizable: true,
  },
  {
    title: "TT hôn nhân",
    key: "tinhTrangHonNhan",
    show: false,
    dataIndex: "tinhTrangHonNhan",
    width: 80,
    align: "left",
    render(value) {
      switch (value) {
        case "0":
          return "Độc thân";
        case "1":
          return "Đã kết hôn";
        default:
          break;
      }
    },
    isResizable: true,
  },
  {
    title: "Học vấn cao nhất",
    key: "hocVanCaoNhat",
    show: false,
    dataIndex: "hocVanCaoNhat",
    width: 80,
    align: "left",
    isResizable: true,
  },

  {
    title: "Chuyên ngành",
    key: "chuyenNganh",
    show: false,
    dataIndex: "chuyenNganh",
    width: 80,
    align: "left",
    isResizable: true,
  },
  {
    title: "Chuyên ngành TA",
    key: "chuyenNganh TA",
    show: false,
    dataIndex: "chuyenNganh TA",
    width: 80,
    align: "left",
    isResizable: true,
  },
  {
    title: "Địa chỉ Email cá nhân",
    key: "emailCaNhan",
    show: false,
    dataIndex: "emailCaNhan",
    width: 80,
    align: "left",
    isResizable: true,
  },
  {
    title: "Địa chỉ Email công ty",
    key: "emailCongTy",
    show: false,
    dataIndex: "emailCongTy",
    width: 80,
    align: "left",
    isResizable: true,
  },
  {
    title: "Số CCCD/CMT",
    key: "cccd",
    show: false,
    dataIndex: "cccd",
    width: 80,
    align: "center",
    isResizable: true,
  },
  {
    title: "Ngày cấp",
    key: "ngayCapDto",
    show: false,
    dataIndex: "ngayCapDto",
    width: 80,
    isResizable: true,
    align: "center",
  },
  {
    title: "Nơi cấp",
    key: "noiCap",
    show: false,
    dataIndex: "noiCap",
    width: 80,
    isResizable: true,
    align: "left",
  },
  {
    title: "Nơi cấp TA",
    key: "noiCapTA",
    show: false,
    dataIndex: "noiCapTA",
    width: 80,
    isResizable: true,
    align: "left",
  },
  {
    title: "Trường",
    key: "truong",
    show: false,
    dataIndex: "truong",
    width: 80,
    align: "left",
    isResizable: true,
  },
  {
    title: "Địa chỉ thường trú",
    key: "diaChiThuongTru",
    show: false,
    dataIndex: "diaChiThuongTru",
    width: 80,
    align: "left",
    isResizable: true,
  },
  {
    title: "Địa chỉ thường trú TA",
    key: "diaChiThuongTruTA",
    show: false,
    dataIndex: "diaChiThuongTruTA",
    width: 80,
    align: "left",
    isResizable: true,
  },
  {
    title: "Địa chỉ liên hệ",
    key: "diaChiLienHe",
    show: false,
    dataIndex: "diaChiLienHe",
    width: 80,
    isResizable: true,
    align: "left",
  },
  {
    title: "Ghi chú",
    key: "ghiChu",
    show: false,
    dataIndex: "ghiChu",
    width: 80,
    align: "left",
    isResizable: true,
  },
  {
    title: "Ngày vào làm",
    key: "ngayVaoLamDto",
    show: false,
    dataIndex: "ngayVaoLamDto",
    width: 80,
    align: "center",
    isResizable: true,
  },
  {
    title: "Ngày nghỉ việc",
    key: "ngayNghiViecDto",
    show: false,
    dataIndex: "ngayNghiViecDto",
    width: 80,
    align: "center",
    isResizable: true,
  },
  {
    title: "Lý do nghỉ",
    key: "lyDoNghiViec",
    show: false,
    dataIndex: "lyDoNghiViec",
    width: 80,
    align: "left",
    isResizable: true,
  },
  {
    title: "Số tài khoản",
    key: "soTaiKhoan",
    show: false,
    dataIndex: "soTaiKhoan",
    width: 80,
    align: "right",
    isResizable: true,
  },
  {
    title: "Ngân hàng",
    key: "nganHang",
    show: false,
    dataIndex: "nganHang",
    width: 80,
    align: "left",
    isResizable: true,
  },
  {
    title: "CCCD cấp MST",
    key: "cccdCapMST",
    show: false,
    dataIndex: "cccdCapMST",
    width: 80,
    isResizable: true,
    align: "center",
  },
  {
    title: "Mã số thuế TNCN",
    key: "maSoThueTNCN",
    show: false,
    dataIndex: "maSoThueTNCN",
    width: 80,
    isResizable: true,
    align: "center",
  },
  {
    title: "Ngày cấp STK",
    key: "ngayCapSTKNganHangDto",
    show: false,
    dataIndex: "ngayCapSTKNganHangDto",
    width: 80,
    align: "center",
    isResizable: true,
  },
  {
    title: "Nơi cấp STK",
    key: "noiCapSTKNganHang",
    show: false,
    dataIndex: "noiCapSTKNganHang",
    width: 80,
    align: "left",
    isResizable: true,
  },
  {
    title: "Số người giảm trừ gia cảnh",
    key: "soNguoiPhuThuoc",
    show: false,
    dataIndex: "soNguoiPhuThuoc",
    width: 80,
    align: "right",
    isResizable: true,
  },
  {
    title: "Mã số BHXH",
    key: "maSoBHXH",
    show: false,
    dataIndex: "maSoBHXH",
    width: 80,
    align: "center",
    isResizable: true,
  },
  {
    title: "Số sổ BHYT",
    key: "soBHYT",
    show: false,
    dataIndex: "soBHYT",
    width: 80,
    align: "center",
    isResizable: true,
  },
  {
    title: "Họ tên người liên hệ",
    key: "hoTenNguoiLienHe",
    show: false,
    dataIndex: "hoTenNguoiLienHe",
    width: 80,
    align: "left",
    isResizable: true,
  },
  {
    title: "Quan hệ với CBCNV",
    key: "quanHeVoiCBNV",
    show: false,
    dataIndex: "hoTenNguoiLienHe",
    width: 80,
    align: "left",
    isResizable: true,
  },
  {
    title: "Số điện thoại liên hệ",
    key: "soDienThoaiNguoiQuanHe",
    show: false,
    dataIndex: "soDienThoaiNguoiQuanHe",
    render: (v) => formatPhoneNumber(v),
    align: "center",
    width: 80,
    isResizable: true,
  },

  {
    title: "Tác vụ",
    dataIndex: "action",
    show: true,
    align: "center",
    fixed: "right",
    width: 100,
  },
];

const itemsInputField: DataFormField[] = [
  {
    type: INPUT,
    name: "maNhanVien",
    label: "Mã nhân viên",
    expand: false,
  },
  {
    type: INPUT,
    name: "hoTen",
    expand: false,
    label: "Họ tên",
  },
  {
    type: DATE_DAY_INPUT,
    name: "birthday",
    expand: false,
    label: "Ngày sinh",
  },
  {
    type: COMBO_BOX,
    label: "Giới tính",
    name: "idGioiTinh",
    expand: false,
    options: listGender,
  },
  {
    type: COMBO_BOX,
    name: "idPhongBan",
    expand: false,
    label: "Phòng ban",
  },
  {
    type: COMBO_BOX,
    name: "idChucVu",
    expand: false,
    label: "Chức Vụ",
  },
  {
    type: COMBO_BOX,
    name: "trangThai",
    expand: false,
    label: "Trạng thái",
    options:
    [
      {
        value: "0",
        label: "Đang làm việc",
      },
      {
        value: "1",
        label: "Đã nghỉ việc",
      },
    ]
  },
  {
    type: INPUT,
    name: "cccd",
    label: "Số CMT/CCCD",
    expand: true,
  },
  {
    type: COMBO_BOX,
    name: "noiCap",
    label: "Nơi cấp",
    expand: true,
  },
  {
    type: DATE_DAY_INPUT,
    name: "ngayCapDto",
    label: "Ngày cấp",
    expand: true,
   // optionsTime: { showTime: true, format: FORMAT_TIME.dayFull },
  //  render: (v, r, idx) => {
  //   return <div>{r ? moment.utc(r).format("YYYY-MM-DDTHH:mm:ss.SSSZ") : ""}</div>;
  // }
  },
  {
    type: INPUT,
    name: "dienThoaiDiDong",
    label: "Điện thoại",
    expand: true,
    // rules: [
    //   {
    //     pattern: new RegExp(TEL_NUMBER_REGEX),
    //     message: "chỉ cho phép nhập số",
    //   },
    // ],
  },
  {
    type: INPUT,
    name: "emailCaNhan",
    label: "Email cá nhân",
    expand: true,
  },
  {
    type: INPUT,
    name: "emailCongTy",
    label: "Email công ty",
    expand: true,
  },
  {
    type: COMBO_BOX,
    name: "tonGiao",
    label: "Tôn giáo",
    expand: true,
  },
  {
    type: COMBO_BOX,
    name: "danToc",
    label: "Dân tộc",
    expand: true,
  },
  {
    type: COMBO_BOX,
    name: "tinhTrangHonNhan",
    label: "TT hôn nhân",
    expand: true,
    options: listMarriage,
  },
  {
    type: COMBO_BOX,
    name: "quocTich",
    label: "Quốc tịch",
    expand: true,
  },
  {
    type: INPUT,
    name: "soGiayPhepHanhNghe",
    label: "Số giấy phép hành nghề",
    expand: true,
  },
];

export { allColumns, itemsInputField };
